import NavBar from "../common/NavBar";
import NavBarFooter from "../common/NavBarFooter";

const Privacy = () => {
    return (
        <div className="outline">
            <NavBar />
            <h1>Privacy Page</h1>
            <p>Relax we won't sell your data to Russian Hackers.</p>
            <NavBarFooter />
        </div>
    )
}

export default Privacy;